// biome-ignore format: historic
import useNode from '@hooks/use-node';
import { useEffect } from 'react';

/**
 * Track changes to an Element's content or border box (or the bounding box of an SVGElement) and
 * triggers a callback invocation in each instance.
 * @param callback Called whenever the dimensions of the element to be tracked change
 */
export default function useResizeObserver<T extends HTMLElement>(
  callback: ResizeObserverCallback,
): React.RefCallback<T> {
  const [node, ref] = useNode<T>();

  useEffect(() => {
    function initObserver(targetNode: T) {
      const resizeObserver = new ResizeObserver(callback);

      resizeObserver.observe(targetNode);

      return () => resizeObserver.unobserve(targetNode);
    }

    if (window.ResizeObserver && node) {
      return initObserver(node);
    }
  }, [node, callback]);

  return ref;
}
